export default __webpack_public_path__ + "static/media/GG.893ec8d1.svg";